"use client";

import { cn } from "@guru/shared/utils/cn";
import { useEffect } from "react";
import { trackMarketingEvent } from "@/lib/marketing/analytics";
import { PERSONA_CONTENT } from "./persona-data";
import { PERSONAS, usePersonaStore } from "./persona-store";

/**
 * The persona lens: "I run a…" chip row. Selection re-skins every demo and
 * mock artefact on the page with that audience's vocabulary.
 */
export function PersonaChips({ className }: { className?: string }) {
  const persona = usePersonaStore((state) => state.persona);
  const setPersona = usePersonaStore((state) => state.setPersona);

  // Store is created with skipHydration so SSR HTML matches the first
  // client render; pick up the persisted lens after mount.
  useEffect(() => {
    void usePersonaStore.persist.rehydrate();
  }, []);

  return (
    <fieldset className={cn("border-0 p-0", className)}>
      <legend className="mb-2 text-sm text-muted-foreground">I run…</legend>
      <div className="flex flex-wrap gap-2">
        {PERSONAS.map((option) => {
          const selected = option === persona;
          return (
            <button
              key={option}
              type="button"
              aria-pressed={selected}
              onClick={() => {
                setPersona(option);
                trackMarketingEvent("persona_selected", { persona: option });
              }}
              className={cn(
                "rounded-full border px-3.5 py-1.5 text-sm transition-colors",
                "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
                selected
                  ? "border-brand bg-brand/15 font-semibold text-brand-deep"
                  : "border-border bg-card text-muted-foreground hover:border-brand/40 hover:text-foreground"
              )}
            >
              {PERSONA_CONTENT[option].chipLabel}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
